/*eslint no-script-url: 0 */
import React, { Component } from 'react';
//import Constants from '../../Config/Config';
import {Loader} from '../../Helpers/Helpers';
import classNames from 'classnames';
import $ from "jquery";

var q, v = Math.PI / 180;

var canvas;
var context;

var dstImage;
var dstCtxImage;

var dstFrame;
var dstFrameCtx;

var dstFrameImage;
var dstFrameCtxImage;

var ia1, ja1, ka, la, ma, na;

var image_width, image_height;

export default class FrameImageWork extends Component {

	constructor(props) {
	    super(props);
	    this.state = {
			frameIsLoading: false,
			backView: false
		}
		this.handleChange = this.handleChange.bind(this);
  	}

	componentDidUpdate(prevProps, prevState) {
        if ( prevProps.wrapEdge !== this.props.wrapEdge || prevProps.selectedStretching !== this.props.selectedStretching || prevProps.frameImageHeight !== this.props.frameImageHeight || prevProps.frameImageWidth !== this.props.frameImageWidth ) {
            this.preview_3d(image_width, image_height)
		}

		if ( prevProps.selectedFrame !== this.props.selectedFrame || prevProps.frameImageHeight !== this.props.frameImageHeight || prevProps.frameImageWidth !== this.props.frameImageWidth ) {
            this.drawFrame()
		}

		if ( prevProps.frameImage !== this.props.frameImage && this.props.frameImage !== null ) {
			this.drawImage()
		}

		if ( (prevProps.frameImage !== this.props.frameImage && this.props.frameImage !== null) || prevState.backView !== this.state.backView || prevProps.selectedHanging !== this.props.selectedHanging || prevProps.selectedLayout !== this.props.selectedLayout ) {
			this.preview_3d_prepare()
        }
	}

	componentDidMount() {
		this.preview_3d();
		this.prepareCanvas();
		if (this.props.frameImage !== null) {
			this.drawImage()
		}
	}

	prepareCanvas() {
		canvas = document.getElementById('framepreview');
		context = canvas.getContext("2d");

		let {frameImageHeight, frameImageWidth} = this.props;

		if (parseFloat(frameImageHeight) <= 0)
			frameImageHeight = 20
		if (parseFloat(frameImageWidth) <= 0)
			frameImageWidth = 20

		q = Math.min(1e3 / frameImageWidth, 1e3 / frameImageHeight);

		canvas.width = frameImageWidth * q;
		canvas.height = frameImageHeight * q;

		dstImage = document.createElement('canvas');
		dstCtxImage = dstImage.getContext('2d');

		dstCtxImage.fillStyle = '#fff';
		dstCtxImage.fillRect(0, 0, canvas.width, canvas.height);
		dstCtxImage.save();

		dstCtxImage.save();
		dstCtxImage.shadowBlur = 20;
		dstCtxImage.shadowOffsetX = 0;
		dstCtxImage.shadowOffsetY = 0;
		dstCtxImage.shadowColor = 'rgba(68,68,68,0.5)';
		dstCtxImage.lineWidth = 15;
		var ja = dstCtxImage.lineWidth / 2;
		dstCtxImage.strokeRect(0 - ja, 0 - ja, canvas.width + 2 * ja, canvas.height + 2 * ja);
		dstCtxImage.restore();
	}

	drawImage() {
		const {frameImage} = this.props;
		var self = this;

		dstFrameImage = document.createElement('canvas');
		dstFrameCtxImage = dstFrameImage.getContext('2d');

		this.setState({frameIsLoading: true});

		// Load images
		// -----------
		var frameImageO = new Image();
		frameImageO.src = frameImage;
		frameImageO.setAttribute('crossOrigin', 'anonymous');
		frameImageO.onload = function() {
			dstFrameImage.width = frameImageO.width;
			dstFrameImage.height = frameImageO.height;
			dstFrameCtxImage.drawImage(frameImageO, 0, 0);
			self.drawFrame()
		};
	}

	drawFrame() {
		this.checkSizes()
		this.setState({frameIsLoading: true});

		const {selectedFrame} = this.props;
		let {frameImageHeight, frameImageWidth} = this.props;

		if (parseFloat(frameImageHeight) <= 0)
			frameImageHeight = 20
		if (parseFloat(frameImageWidth) <= 0)
			frameImageWidth = 20

		var self = this;
		q = Math.min(1e3 / frameImageWidth, 1e3 / frameImageHeight);

		canvas.width = frameImageWidth * q;
		canvas.height = frameImageHeight * q;

		//console.log('Width: '+canvas.width)
		//console.log('Height: '+canvas.height)

		if (selectedFrame.size > 0) {
			var frameSImage = new Image();
			frameSImage.src = selectedFrame.get('square_image');
			frameSImage.setAttribute('crossOrigin', 'anonymous');
			frameSImage.onload = function() {
				var matia1 = 0
				var matja1 = 0

				var typeWidth = selectedFrame.getIn(['dimensions', 'width']);

				ia1 = parseFloat(typeWidth) * q
				ja1 = parseFloat(typeWidth) * q
				ka = parseFloat(typeWidth) * q
				la = parseFloat(typeWidth) * q
				ma = parseFloat(canvas.width) + ia1 + ja1
				na = parseFloat(canvas.height) + ka + la

				dstFrame = document.createElement('canvas');
				dstFrame.width = ma;
				dstFrame.height = na;
				dstFrameCtx = dstFrame.getContext('2d');

				canvas.width = dstFrame.width;
				canvas.height = dstFrame.height;

				var ra = frameSImage.height
				var sa = parseFloat((q * typeWidth / ra).toFixed(2))
				var ta = parseInt(dstFrame.width / sa, 10)
				var ua = parseInt(dstFrame.height / sa, 10)

				dstFrameCtx.fillStyle = dstFrameCtx.createPattern(frameSImage, 'repeat-x')
				dstFrameCtx.save()
				dstFrameCtx.scale(sa, sa)
				dstFrameCtx.fillRect(0, 0, ta, frameSImage.height)
				dstFrameCtx.restore()
				dstFrameCtx.save()
				dstFrameCtx.scale(sa, sa)
				dstFrameCtx.beginPath()
				dstFrameCtx.translate(ta, ua)
				dstFrameCtx.rotate(180 * v)
				dstFrameCtx.moveTo(0, 0)
				dstFrameCtx.fillRect(0, 0, ta, frameSImage.height)
				dstFrameCtx.rotate(180 * v)
				dstFrameCtx.restore()
				dstFrameCtx.save()
				dstFrameCtx.scale(sa, sa)
				dstFrameCtx.translate(0, ua)
				dstFrameCtx.rotate( - 90 * v)
				dstFrameCtx.beginPath()
				dstFrameCtx.moveTo(0, 0)
				dstFrameCtx.lineTo(frameSImage.height, frameSImage.height)
				dstFrameCtx.lineTo(ua - frameSImage.height, frameSImage.height)
				dstFrameCtx.lineTo(ua, 0)
				dstFrameCtx.lineTo(0, 0)
				dstFrameCtx.closePath()
				dstFrameCtx.clip()
				dstFrameCtx.fill()
				dstFrameCtx.rotate(90 * v)
				dstFrameCtx.translate(0, -ua)
				dstFrameCtx.restore()
				dstFrameCtx.save()
				dstFrameCtx.scale(sa, sa)
				dstFrameCtx.translate(ta, 0)
				dstFrameCtx.rotate(90 * v)
				dstFrameCtx.beginPath()
				dstFrameCtx.moveTo(0, 0)
				dstFrameCtx.lineTo(frameSImage.height, frameSImage.height)
				dstFrameCtx.lineTo(ua - frameSImage.height, frameSImage.height)
				dstFrameCtx.lineTo(ua, 0)
				dstFrameCtx.lineTo(0, 0)
				dstFrameCtx.closePath()
				dstFrameCtx.clip()
				dstFrameCtx.fill()
				dstFrameCtx.rotate( - 90 * v)
				dstFrameCtx.translate( - ta, 0)
				dstFrameCtx.restore()

				// Frame corners
				context.drawImage(dstFrame, 0, 0, dstFrame.width, dstFrame.height, 0, 0, canvas.width, canvas.height);

				// Main Image
				if (self.props.frameImage !== null) {
					context.drawImage(dstFrameImage, 0, 0, dstFrameImage.width, dstFrameImage.height, ia1 + matia1, ia1 + matia1, canvas.width - (ia1 + ja1 + matia1 + matja1), canvas.height - (ia1 + ja1 + matia1 + matja1));
				} else {
					context.drawImage(dstImage, 0, 0, dstImage.width, dstImage.height, ia1 + matia1, ia1 + matia1, canvas.width - (ia1 + ja1 + matia1 + matja1), canvas.height - (ia1 + ja1 + matia1 + matja1));
				}

				self.props.dispatch({
					type: 'SET_STATE',
					state: {
						canvasImage: canvas.toDataURL()
					}
				})
				self.generateThumb();
			};
		} else {
			// Main Image
			if (self.props.frameImage !== null) {
				context.drawImage(dstFrameImage, 0, 0, dstFrameImage.width, dstFrameImage.height, 0, 0, canvas.width, canvas.height);
			} else {
				context.drawImage(dstImage, 0, 0, dstImage.width, dstImage.height, 0, 0, canvas.width, canvas.height);
			}

			self.props.dispatch({
				type: 'SET_STATE',
				state: {
					canvasImage: canvas.toDataURL()
				}
			})
			self.generateThumb();
		}
	}

	generateThumb() {
		var self = this;
		var thumbSize = 250;
		var canvasThumb = document.getElementById("framepreview");

		var thumbDim = Math.min(thumbSize / canvasThumb.width, thumbSize / canvasThumb.height)

		var canvasThumbEle = document.createElement('canvas');
		canvasThumbEle.width = Math.floor(canvasThumb.width * thumbDim);
		canvasThumbEle.height = Math.floor(canvasThumb.height * thumbDim);
		var thumbContext = canvasThumbEle.getContext("2d");

		var imgCanvas = new Image();
		imgCanvas.onload = function(e) {
			thumbContext.fillStyle = '#FFFFFF'
			thumbContext.fillRect(0, 0, canvasThumbEle.width, canvasThumbEle.height)
			thumbContext.scale(thumbDim, thumbDim)
		    thumbContext.drawImage(canvasThumb, 0, 0);
			self.props.dispatch({
				type: 'SET_STATE',
				state: {
					canvasThumbImage: canvasThumbEle.toDataURL()
				}
			})
			self.setState({frameIsLoading: false});
		};
		imgCanvas.src = this.props.canvasImage;
	}

	checkSizes() {
		const {frameImageHeight, frameImageWidth} = this.props;

		// Images size
		if(frameImageWidth < 20 || frameImageWidth > 125 || frameImageHeight < 20 || frameImageHeight > 125) {
	        this.props.dispatch({
	            type: 'SET_STATE',
	            state: {
	                imageSizeError: true
	            }
	        });
		} else {
	        this.props.dispatch({
	            type: 'SET_STATE',
	            state: {
	                imageSizeError: false
	            }
	        });
		}
	}

	preview_3d_prepare() {
		const {frameImage, selectedLayout, selectedHanging} = this.props;
		const {backView} = this.state;
		var output = '';
		var canvas_preview_output = '';
		var self = this;
		var imageSRC = frameImage;
		if (backView) {
			if (selectedHanging.size > 0)
				imageSRC = selectedHanging.getIn(['_embedded', 'wp:featuredmedia', 0, 'media_details', 'sizes', 'full', 'source_url']);
			else
				imageSRC = selectedLayout.getIn(['images', 0, 'src']);
		}

		var image = new Image();
		image.src = imageSRC
		image.className = 'canvas';
		image.onload = function() {

			$('.canvas-target').html(image);
			var img = $('.customize .canvas');

			img.css({
				'max-width': $('.img_set_sec').width(),
				'max-height': $('.img_set_sec').height(),
				'margin': '0px auto !important',
				'display': 'none'
			});

			canvas_preview_output += '<div class="canvas-preview-container">';
			canvas_preview_output += '<div class="canvas-preview">';
			canvas_preview_output += '<div class="preview-front">';
			canvas_preview_output += '<div class="front-crop">';
			canvas_preview_output += '<div class="img-container">';
			canvas_preview_output += '<img src="' + imageSRC + '">'
			canvas_preview_output += '</div>';
			canvas_preview_output += '</div>';
			canvas_preview_output += '</div>';
			canvas_preview_output += '<div class="preview-left">';
			canvas_preview_output += '<div class="left-crop border">';
			canvas_preview_output += '<div class="img-container">';
			canvas_preview_output += '<img src="' + frameImage + '">'
			canvas_preview_output += '</div>';
			canvas_preview_output += '</div>';
			canvas_preview_output += '</div>';
			canvas_preview_output += '<div class="preview-right">';
			canvas_preview_output += '<div class="right-crop border">';
			canvas_preview_output += '<div class="img-container">';
			canvas_preview_output += '<img src="' + frameImage + '">'
			canvas_preview_output += '</div>';
			canvas_preview_output += '</div>';
			canvas_preview_output += '</div>';
			canvas_preview_output += '</div>';
			canvas_preview_output += '</div>';
			output += canvas_preview_output;
			$('.customize .3D-view').html(output);

			if (!backView) {
				image_width = img.width();
				image_height = img.height();
			} else {
				$('.canvas-preview > div img').css('height', image_height)
			}
			//console.log('image_width: ' + image_width)
			//console.log('image_height: ' + image_height)

			self.preview_3d(image_width, image_height)
		}
	}

	preview_3d(image_width, image_height) {
		if (image_width === 0 || image_height === 0 ) {
			this.preview_3d_prepare()
			return;
		}

		const {wrapEdge} = this.props;

		var border_color = 'black', border_class = '', left_only, top_only, right_only, bottom_only;

		if (wrapEdge === 'mirror-wrap')
			border_class = 'mirror-wrap';
		else if (wrapEdge !== 'image-wrap')
			border_class = 'mirror-wrap border-color';

		$('.canvas-preview-container .canvas-preview').removeClass('mirror-wrap').removeClass('border-color');
		$('.canvas-preview-container .canvas-preview').addClass(border_class);

		// Image width and height
		let {frameImageHeight, frameImageWidth} = this.props;

		if (parseFloat(frameImageHeight) <= 0)
			frameImageHeight = 20
		if (parseFloat(frameImageWidth) <= 0)
			frameImageWidth = 20

		// Border color
		if (wrapEdge === 'white')
			border_color = 'white';

		var border_width = 3.5
		var aditional_border_width = 0;
		var crop_x = 0;
		var crop_y = 0;

		if (wrapEdge === 'image-wrap')
			aditional_border_width = border_width * ((image_width - crop_x) / frameImageWidth);

		border_width = ((border_width * ((image_width - crop_x) / frameImageWidth)) / image_width) * 100;

		left_only = (crop_x + aditional_border_width) / image_width * 100;
		right_only = (image_width - aditional_border_width) / image_width * 100;

		top_only = (crop_y + aditional_border_width) / image_height * 100;
		bottom_only = (image_height - aditional_border_width) / image_height * 100;

		var width_ratio = (image_width - crop_x) / image_width;
		var height_ratio = (image_height - crop_y) / image_height;
		var ratio = width_ratio;

		if (height_ratio > ratio)
			ratio = height_ratio;

		$(":root").get(0).style.setProperty('--image_width_only', image_width);
		$(":root").get(0).style.setProperty('--image_height_only', image_height);
		$(":root").get(0).style.setProperty('--depth_only', parseInt(border_width));
		$(":root").get(0).style.setProperty('--border_color', border_color);
		$(":root").get(0).style.setProperty('--left_only', parseInt(left_only));
		$(":root").get(0).style.setProperty('--right_only', parseInt(right_only));
		$(":root").get(0).style.setProperty('--top_only', parseInt(top_only));
		$(":root").get(0).style.setProperty('--bottom_only', parseInt(bottom_only));
		$(":root").get(0).style.setProperty('--ratio', ratio);
	}

	handleChange = (e) => {
		this.setState({
			[e.target.name]: e.target.value,
		});
	}

	render() {
		const {libraryImageUploading, selectedStretching, rightFrameHeight, selectedFrame} = this.props;
		const {frameIsLoading, backView} = this.state;

		const unStreched = classNames('canvas-image', {'hidden': frameIsLoading || libraryImageUploading || ( selectedFrame.size === 0 && selectedStretching.getIn(['title', 'rendered']) === 'Stretched')});
		const streched = classNames('customize', {'hidden': frameIsLoading || libraryImageUploading || selectedStretching.getIn(['title', 'rendered']) !== 'Stretched' || selectedFrame.size > 0});

		/* console.log('------------------')
		console.log(showWhenUnStreched) */

		return (
			<>
				{frameIsLoading /* || libraryImageUploading */ &&
					<Loader />
				}
				<div className={streched}>
					<div className="canvas-target"></div>
					<div className="switch-container">
						<div className="switch-button">
							<span className="crop">Front</span>
							<label className="switch">
								<input
									type="checkbox"
									name="backView"
									checked={backView}
									onChange={(e) => {
										this.handleChange({
											target: {
												name: e.target.name,
												value: e.target.checked,
											},
										});
									}}
								/>
								<div className="slider round"></div>
							</label>
							<span className="back-view">Back</span>
						</div>
					</div>
					<div className="3D-view"></div>
				</div>
				<div className={unStreched}>
					<canvas id="framepreview" style={{maxHeight: rightFrameHeight - 4 +'px'}}></canvas>
				</div>
			</>
		);
	}
}